/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_Rule_EveryInputs */

const vi_packaging_bom_rule_every = /** @type {(inputs: Packaging_Bom_Rule_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cứ`)
};

/**

* @param {Packaging_Bom_Rule_EveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_rule_every = /** @type {((inputs?: Packaging_Bom_Rule_EveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_Rule_EveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_rule_every(inputs)
});